export const privacyPolicyLink = {
    to: '/en/privacy_en',
    text: 'Privacy Policy',
  };
  
  export const termsOfServiceLink = {
    to: '/en/per_sdk_en',
    text: 'Terms of Service',
  };
  export const privacyPolicyLinkRus = {
    to: '/rus/privacy_en',
    text: 'Privacy Policy',
  };
  export const termsOfServiceLinkRus = {
    to: '/rus/per_sdk_en',
    text: 'Terms of Service',
  };
  export const privacyPolicyLinkCht = {
    to: '/cht/privacy_cht',
    text: '隱私政策',
  };
  export const termsOfServiceLinkCht = {
    to: '/cht/per_sdk_cht',
    text: '服務條款',
  };